<div class="video-player-container"
     role="button"
     [ngClass]="{'playing': isPlaying}">
  <video #videoMedia *ngIf="isVideo && completed"
         src="{{srcVideo}}"
         type="video/mp4"
         class="video-player video"
         poster="{{posterImage}}"
         (click)="toggleVideoPlayer()"
         (ended)="afterEndVideo()"
         playsinline></video>
  <div class="video-control" *ngIf="isVideo && completed">
    <span class="video-play-button" role="button" (click)="toggleVideoPlayer()"></span>
  </div>
  <img *ngIf="!isVideo || !completed" src="{{posterImage}}" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" class="video-player image">
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-story-preview/achoo-story-preview.component.html